<template>
  <div
    v-if="visible"
    :class="'fullscreen cvpreview' + className"
    :style="{ width: boxWidth || '', zIndex: `${zindex}` }"
    @contextmenu.prevent.stop="
      () => {
        return false
      }
    "
  >
    <div class="preview-title" @mousedown="domdrag($el, $event)">
      <h2 v-show="!showHighlight">附件预览</h2>
      <div v-show="showHighlight" class="cvpreview-tabs">
        <div class="cvpreview-tab" :class="{ 'cvpreview-tab-active': activeTab == 'file' }" @click="activeTab = 'file'">
          附件预览
        </div>
        <div
          class="cvpreview-tab"
          :class="{ 'cvpreview-tab-active': activeTab == 'highlight' }"
          @click="activeTab = 'highlight'"
        >
          推荐概述辅助填写
        </div>
      </div>
      <div>
        <a v-if="!isMax" class="preview-max" href="javascript:;" title="最大化" @click="max"></a>
        <a v-else class="preview-revert" href="javascript:;" title="还原" @click="revert"></a>
        <a class="preview-close" href="javascript:;" title="关闭" @click="close"></a>
      </div>
    </div>
    <div class="preview-resizeL" @mousedown="resize($el, $event.target, true, false, false, true)"></div>
    <div class="preview-resizeT" @mousedown="resize($el, $event.target, false, true, true, false)"></div>
    <div class="preview-resizeR" @mousedown="resize($el, $event.target, false, false, false, true)"></div>
    <div class="preview-resizeB" @mousedown="resize($el, $event.target, false, false, true, false)"></div>
    <div class="preview-resizeLT" @mousedown="resize($el, $event.target, true, true, false, false)"></div>
    <div class="preview-resizeTR" @mousedown="resize($el, $event.target, false, true, false, false)"></div>
    <div class="preview-resizeBR" @mousedown="resize($el, $event.target, false, false, false, false)"></div>
    <div class="preview-resizeLB" @mousedown="resize($el, $event.target, true, false, false, false)"></div>
    <div v-if="dragLeft" class="preview-cover"></div>

    <div v-loading="loading" class="preview-content col-1" style="position:relative">
      <div v-show="!showHighlight || activeTab == 'file'" style="height: calc(100vh - 120px)">
        <div
          v-if="file && (isAdmin || isShuju || file.type == '推荐报告' || (isFinance && file.type == '付款通知书')) && userInservice"
          class="preview-download"
          @click="downloadFile"
        >
          下载
        </div>
        <!-- <div v-show="mask" class="embed-cover" @scroll.stop.prevent="onScroll"></div> -->
        <iframe
          v-if="(isOld || isVideo)"
          v-show="!isImgUrl"
          id="iframe"
          :src="`${previewUrl}#toolbar=0`"
          width="100%"
          height="100%"
          frameborder="no"
          border="0"
          marginwidth="0"
          marginheight="0"
          scrolling="auto"
          allowtransparency="yes"
        />
        <div v-viewer style="max-height: 100%; overflow-y: auto;"><img v-show="isImgUrl" :src="previewUrl" /></div>
        <div
          v-show="!isOld && isOfficeUrl"
          id="testIframe"
          :style="`height:85vh !important`"
        ></div>
      </div>

      <div
        v-show="showHighlight && activeTab == 'highlight'"
        style="padding:10px 15px;line-height:1.8;height: calc(100vh - 120px);overflow: auto;;color: #444;"
      >
        <template v-if="recommendTexts.length > 0">
          <div style="font-size:14px;margin-bottom:5px;color:#999">
            <i class="el-icon-s-order" style="font-size:14px;margin-right:5px"></i> <span>过往推荐概述：</span>
          </div>
          <div
            v-show="recommendTexts.length > 0"
            style="padding: 0 15px;font-size:14px;border-bottom: 1px solid #eee;margin-bottom: 10px;"
          >
            <span v-show="recommendTexts.length > 1" class="rp-a-link" @click="nextTextIndex" style="margin-right:20px">
              <i class="el-icon-refresh"></i> 换一个
            </span>
            <span class="rp-a-link" @click="copyText"> <i class="el-icon-document-copy"></i> 复制 </span>
          </div>
          <div style="white-space: pre-wrap;padding:0 15px;">{{ recommendTexts[recommendTextIndex] }}</div>
          <div class="cvpv-line"></div>
        </template>
        <template v-if="records.length">
          <div style="font-size:14px;margin-bottom:5px;color:#999">
            <i class="el-icon-s-order" style="font-size:14px;margin-right:5px"></i> <span>沟通备注：</span>
          </div>
          <div v-for="(item, k) in records" :key="k + 'e'">
            <div class="remark-date">{{ item.date }} -- {{ item.user }}</div>
            <div class="remark-info"><span v-html="formatAnswer(item.answer)"></span></div>
          </div>
          <div class="cvpv-line"></div>
        </template>
        <template v-if="pipeiduText">
          <div style="font-size:14px;margin-bottom:5px;color:#999">
            <i class="el-icon-s-order" style="font-size:14px;margin-right:5px"></i> <span>系统建议推荐概述：</span>
          </div>
          <div style="margin-bottom:5px;padding:0 15px">{{ pipeiduText || '无' }}</div>
          <div class="cvpv-line"></div>
        </template>
        <template v-if="risks.contents.length || risks.tags.length">
          <div style="color:#e67702;font-size:14px">
            <i class="el-icon-warning" style="font-size:14px;margin-right:5px"></i>
            <span>注意点X{{ risks.contents.length }}</span>
          </div>
          <div>
            <el-tag v-for="(item, k) in risks.tags" :key="k + 'd'" size="mini" type="warning" style="margin:5px 3px">{{
              item
            }}</el-tag>
          </div>
          <div v-for="(item, k) in risks.contents" :key="k + 'c'">
            <i class="el-icon-s-help" style="color:#e67702;margin-right:5px"></i> <span>{{ item }}</span>
          </div>
          <div class="cvpv-line"></div>
        </template>
        <template v-if="highlights.contents.length || highlights.tags.length">
          <div style="color:#a5ad74;font-size:14px">
            <i class="el-icon-s-opportunity" style="font-size:14px;margin-right:5px"></i>
            <span>简历亮点X{{ highlights.contents.length }}</span>
          </div>
          <div>
            <el-tag v-for="(item, k) in highlights.tags" :key="k + 'b'" size="mini" style="margin:5px 3px">{{
              item
            }}</el-tag>
          </div>
          <div v-for="(item, k) in highlights.contents" :key="k + 'a'">
            <i class="el-icon-s-help" style="color:#a5ad74;margin-right:5px"></i> <span>{{ item }}</span>
          </div>
        </template>
      </div>
      
      <template v-if="!isShuju || (isShuju && !showHighlight)">
        <div
          v-for="i in 8"
          :key="i"
          class="alpha-water-mark-one"
          :style="{ top: (Math.ceil(i / 2) - 1) * 200 + 'px', left: i % 2 == 1 ? '20%' : '60%' }"
        >
          {{ account }}
        </div>
      </template>
    </div>

    <!-- <div class="preview-close ft-danger"><i class="el-icon-close" @click="close" /></div> -->
  </div>
</template>

<script>
// TODO: 这里的预览需要用户已登录，为了方便复制了一份PublicPreview，不需要登录，且只能预览上传到publicUploads的文件
import { download } from '../../../project/src/constant/utils'
// import WPSOfficeSDK from '../../../assets/weboffice/web-office-sdk-v1.1.2.es'
const dateFormat = require('dateformat')

// let wpsOfficeInstance

export default {
  props: {
    className: { type: String, default: '' },
  },
  data() {
    return {
      file: undefined,
      previewUrl: undefined,
      visible: false,
      boxWidth: '40vw',
      loading: false,
      dragMinWidth: 250,
      dragMinHeight: 124,
      isMax: false,
      dragLeft: false,
      zindex: 1000,
      // 是否在职，在职true
      userInservice: true,
      token: '',
      isOld: false,

      showHighlight: false,
      activeTab: 'file',
      pipeiduText: '',
      highlights: { tags: [], contents: [] },
      risks: { tags: [], contents: [] },
      recommendTexts: [],
      recommendTextIndex: 0,
      records: [],
      config: {
        document: {
          fileType: 'docx',
          key: '',
          title: '',
          permissions: {
            chat: false,
            comment: false,
            copy: false,
            download: false,
            edit: false,
            fillForms: false,
            modifyContentControl: false,
            modifyFilter: false,
            print: false,
            review: false,
            reviewGroups: null,
            commentGroups: {},
            userInfoGroups: null,
          },
          // url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/test1.html',
          url:
            'https://alphahr.oss-cn-beijing.aliyuncs.com/public/d32bfbcd863860b41535f5fc1923396d.%E6%98%93%E7%A5%96%E6%B1%9F-%E7%A8%8E%E5%8A%A1%E8%B4%9F%E8%B4%A3%E4%BA%BA-%E4%B8%AD%E5%A4%96%E5%90%88%E8%90%A5%EF%BC%88%E5%90%88%E8%B5%84%C2%B7%E5%90%88%E4%BD%9C%EF%BC%89-%E7%94%B7-32%E5%B2%81-%E7%A1%95%E5%A3%AB-8%E5%B9%B4%E4%BB%A5%E4%B8%8A%E5%B7%A5%E4%BD%9C%E7%BB%8F%E9%AA%8C%E7%8C%8E%E8%81%98%E7%AE%80%E5%8E%86.docx',
        },
        documentType: 'word',
        editorConfig: {
          actionLink: null,
          callbackUrl: 'http://47.93.158.22:11000/example/track?filename=new.docx&useraddress=27.47.132.115',
          coEditing: null,
          createUrl: null,
          customization: {
            about: false,
            comments: false,
            feedback: false,
            forcesave: false,
            submitForm: false,
            compactHeader: true,
            compactToolbar: true,
            hideRightMenu: true,
            hideRulers: true,
            toolbarNoTabs: true,
            // zoom: -1,
            features: {
              spellcheck: false,
            },
            integrationMode: 'embed',
            logo: {
              image: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/assets/alpha-logo.png',
            },
          },
          user: {
            group: '',
            id: app.user._id,
            name: app.user.account || 'test',
          },
          region: 'zh-CN',
          lang: 'zh-CN',
          plugins: false,
        },
        mode: 'view',
        height: '100%',
        width: '100%',
        type: 'desktop',
      },
      originalname: '',
      documentType: 'word',
      fileType: 'docx',
      md5: '',
      docEditor: null,
    }
  },
  computed: {
    suffix() {
      const previewUrl = this.previewUrl
      return (previewUrl && previewUrl.substr(previewUrl.lastIndexOf('.') + 1)) || ''
    },
    isAdmin() {
      return app.user.角色 && app.user.角色.includes('管理员')
    },
    isFinance() {
      return app.user.角色 && app.user.角色.includes('财务')
    },
    isShuju() {
      return app.user.角色 && app.user.角色.includes('数据处理')
    },
    isOfficeUrl() {
      const wordTypeReg = /(\.doc)|(\.docm)|(\.docx)|(\.docxf)|(\.dot)|(\.dotm)|(\.dotx)|(\.epub)|(\.fodt)|(\.fb2)|(\.htm)|(\.html)|(\.mht)|(\.odt)|(\.oform)|(\.ott)|(\.oxps)|(\.pdf)|(\.rtf)|(\.txt)|(\.djvu)|(\.xml)|(\.xps)/
      const excelTypeReg = /(\.csv)|(\.fods)|(\.ods)|(\.ots)|(\.xls)|(\.xlsb)|(\.xlsm)|(\.xlsx)|(\.xlt)|(\.xltm)|(\.xltx)/
      const pptTypeReg = /(.fodp)|(\.odp)|(\.otp)|(\.pot)|(\.potm)|(\.potx)|(\.pps)|(\.ppsm)|(\.ppsx)|(\.ppt)|(\.pptm)|(\.pptx)/
      return wordTypeReg.test(this.previewUrl) || excelTypeReg.test(this.previewUrl) || pptTypeReg.test(this.previewUrl)
    },
    isImgUrl() {
      return /(\.png)|(\.jpg)|(\.jpeg)|(\.bmp)|(\.gif)|(\.webp)|(\.tif)/.test(this.previewUrl)
    },
    isVideo() {
      return /(\.mp4)|(\.mkv)|(\.avi)|(\.mov)|(\.m4a)|(\.m4v)|(\.mpeg)|(\.flv)/.test(this.previewUrl)
    },
    account() {
      return app.user.account
    },
  },
  mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
    this.config.events = {
      onError: this.destoryEditor(),
      onRequestClose: this.destoryEditor(),
    }
    // this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
  },
  methods: {
    downloadFile() {
      if (this.file) download(this.file)
    },
    max() {
      this.$el.style.left = 0
      this.$el.style.top = '60px'
      this.$el.style.width = '100vw'
      this.$el.style.height = 'calc(100vh - 60px)'
      this.isMax = true
    },
    revert() {
      this.$el.style.left = 0
      this.$el.style.top = '60px'
      this.$el.style.width = this.boxWidth
      this.$el.style.height = 'calc(100vh - 60px)'
      this.isMax = false
    },
    close() {
      try {
        this.destoryEditor()
      } catch (e) {
        console.error(e)
      }
      this.$nextTick(() => {
        this.visible = false
      })
    },
    destoryEditor() {
      this.docEditor && this.docEditor.destroyEditor()
      this.docEditor = null
    },
    loadFileByUrl(url) {
      this.previewUrl = url
      this.show()
    },
    formatAnswer(answer) {
      if (!answer) return ''
      return answer.replace(/\n+/g, '<br/>').replace(' ', '&nbsp;')
    },
    async getFile(file, params = {}) {
      const { md5, fileId, _id } = file
      if (!md5 && !fileId && !_id) return
      this.loading = true
      this.file = file
      const { showHighlight, pid, rid, width } = params
      this.showHighlight = !!showHighlight
      this.boxWidth = width || '40vw'
      let fileData
      this.pipeiduText = ''
      this.highlights = { tags: [], contents: [] }
      this.risks = { tags: [], contents: [] }
      this.recommendTexts = []
      this.recommendTextIndex = 0
      this.records = []
      try {
        if (rid) {
          const res = await app.service('radish').getRadishPrevousRecommendText({ rid })
          if (res && res.status === 'success') {
            this.recommendTexts = res.data || []
          }
          // 获取沟通备注
          const data = await app.service('communication').testPaper({ radishId: rid })
          if (data) {
            this.records = data.remark
              .sort((a, b) => (a.time < b.time ? 1 : -1))
              .map(item => {
                const { answer, stem, time, user } = item
                const date = dateFormat(new Date(parseInt(time, 10)), 'yyyy-mm-dd HH:MM')
                return {
                  answer,
                  stem,
                  date,
                  user,
                }
              })
          }
        }
        if (rid && pid) {
          const rp = await app.service('radish').getRadishProject({ rid, pid })
          if (rp.status == 'success' && rp.data) {
            if (rp.data.pipeiduText) {
              this.pipeiduText = rp.data.pipeiduText
            } else {
              const pi = await app.service('radish').initRecommendText({ rid, pid })
              this.pipeiduText = pi.data.pipeiduText
            }
          }
        }
        if (this.showHighlight) {
          if (!file.data || !file.data.人才画像预测) {
            file.data = await app.service('file').analyse({ md5: file.md5, force: true, category: 'xxAnalyze' })
            fileData = file.data
          }
          this.activeTab = 'file'
          if (file.data && file.data.人选画像预测) {
            const hls = file.data.人选画像预测.highlights
            const risks = file.data.人选画像预测.risks
            if (hls) {
              this.highlights = {
                tags: hls.tags,
                contents: [...hls.project, ...hls.occupation, ...hls.education, ...hls.others],
              }
            }
            if (risks) {
              this.risks = {
                tags: risks.tags,
                contents: [...risks.occupation, ...risks.education],
              }
            }
          }
        }

        const query = md5 ? { md5 } : fileId || _id ? { _id: fileId || _id } : undefined
        const src = await window.app.service('file').buildPreview(query)
        const url = src.url
        if (window.location.origin.indexOf('https://') !== -1) {
          this.previewUrl = url.replace('http://', 'https://')
        } else if (window.location.origin.indexOf('http://') !== -1) {
          this.previewUrl = url.replace('https://', 'http://')
        }
        this.documentType = src.documentType
        this.originalname = src.originalname
        this.fileType = src.fileType
        this.md5 = src.md5
        this.show()
      } catch (error) {
        this.$message.error(`预览：${(error.response && error.response.message) || error.message}`)
        this.close()
      }
      this.loading = false
      return fileData
    },
    show() {
      // this.revert()
      this.visible = true
      this.zindex = app.root.dragindex++
      if (this.isOfficeUrl) {
        this.config.documentType = this.documentType
        this.config.document.fileType = this.fileType
        this.config.document.key = this.md5
        this.config.document.title = this.originalname
        this.config.document.url = this.previewUrl
        this.config.events = {
          onError: this.destoryEditor(),
          onRequestClose: this.destoryEditor(),
        }
        if (this.isShuju || this.isAdmin) {
          this.config.document.permissions.copy = true
        }
      }
      this.$nextTick(() => {
        if (!this.docEditor && this.isOfficeUrl) {
          this.docEditor = new window.DocsAPI.DocEditor('testIframe', this.config)
        }
        this.revert()
      })
    },
    domdrag($el, event) {
      let startX, startY, clientX, clientY
      let isDrag = false
      event.preventDefault()
      // $el.style.zIndex = app.root.dragindex++
      startX = $el.offsetLeft
      startY = $el.offsetTop
      clientX = event.clientX
      clientY = event.clientY
      isDrag = true
      document.addEventListener('mousemove', e => {
        if (isDrag) {
          e.preventDefault()
          $el.style.left = `${e.clientX - clientX + startX}px`
          $el.style.top = `${e.clientY - clientY + startY}px`
        }
      })
      document.addEventListener('mouseup', e => {
        isDrag = false
      })
    },
    resize(oParent, handle, isLeft, isTop, lockX, lockY) {
      const { dragMinWidth, dragMinHeight, $el } = this
      const showCover = val => (this.dragLeft = val)
      handle.onmousedown = e => {
        showCover(true)
        const event = e || window.event
        const disX = event.clientX - handle.offsetLeft
        const disY = event.clientY - handle.offsetTop
        const iParentTop = oParent.offsetTop
        const iParentLeft = oParent.offsetLeft
        const iParentWidth = oParent.offsetWidth
        const iParentHeight = oParent.offsetHeight

        const iframe = $el.querySelector('#iframe')
        let iframeDocument = iframe.contentDocument

        if (iframeDocument) {
          iframeDocument.onmousemove = mouseMove
          iframeDocument.onmouseup = mouseUp
        } else {
          iframe.onload = function() {
            iframeDocument = iframe.contentDocument
            iframeDocument.onmousemove = mouseMove
            iframeDocument.onmouseup = mouseUp
          }
        }

        document.onmousemove = mouseMove
        document.onmouseup = mouseUp

        function mouseUp() {
          document.onmousemove = null
          document.onmouseup = null
          iframeDocument && (iframeDocument.onmousemove = null)
          iframeDocument && (iframeDocument.onmouseup = null)
          showCover(false)
        }
        function mouseMove(e) {
          const event = e || window.event
          const iL = event.clientX - disX
          const iT = event.clientY - disY
          const maxW = document.documentElement.clientWidth - oParent.offsetLeft - 2
          const maxH = document.documentElement.clientHeight - oParent.offsetTop - 2
          let iW = isLeft ? iParentWidth - iL : handle.offsetWidth + iL
          let iH = isTop ? iParentHeight - iT : handle.offsetHeight + iT
          const newTop = iParentTop + iT

          isLeft && iW >= dragMinWidth && (oParent.style.left = `${iParentLeft + iL}px`)
          iW < dragMinWidth && (iW = dragMinWidth)
          iW > maxW && (iW = maxW)
          lockX || (oParent.style.width = `${iW}px`)
          isTop && iH >= dragMinHeight && (oParent.style.top = `${newTop < 41 ? 41 : newTop}px`)
          iH < dragMinHeight && (iH = dragMinHeight)
          iH > maxH && (iH = maxH)
          lockY || (oParent.style.height = `${iH}px`)
          return false
        }

        return false
      }
    },
    nextTextIndex() {
      if (this.recommendTextIndex == this.recommendTexts.length - 1) {
        this.recommendTextIndex = 0
      } else {
        this.recommendTextIndex++
      }
    },
    copyText() {
      if (this.recommendTexts[this.recommendTextIndex]) {
        const oTextarea = document.createElement('textarea')
        oTextarea.value = this.recommendTexts[this.recommendTextIndex]
        document.body.appendChild(oTextarea)
        oTextarea.select()
        document.execCommand('Copy')
        document.body.removeChild(oTextarea)
        this.$message.success('复制成功')
      }
    },
  },
}
</script>

<style src="../../statics/css/cvpreview.css"></style>
